import React, { useState, useEffect } from "react";
import styles from './product-synonyms.scss';
import { connect } from 'react-redux'
import withRipple from 'jd-library/withRipple';
import AddEditSynonyms from './AddEditSynonyms';
import { updateEditProductDetail } from '../../actions/products';

const ProductSynonyms = (props) => {
	const [synonyms, updateSynonyms] = useState([]);
    const [synonymsSlider, toggleSynonymsSlider] = useState(false);

	useEffect(() => {
		if(props.synonyms){
            let data = props.synonyms.split('€');
            updateSynonyms(data);
        }
	},[]);

    const onSaveSynonyms = (sysnoymsData) => {
        let data = [...sysnoymsData];
        updateSynonyms(data);
        props.updateEditProductDetail({productSynonym : data.join('€')});
        // props.updateItemInfo({productSynonym : data.join('€')});
    }

    const AddSynonyms = withRipple(props => {
        return(
            <div
                className={'list-box synonym-sec'+ ' ' + (synonyms.length ? styles['prod-synonyms'] : '')+ ' ' + props.rippleClass} onClick = {() => {
                    toggleSynonymsSlider(true);
                }}
                {...props.rippleHandler}
            >
                <div className={styles['synonyms-title-grp']}>
                    <div className={styles['synonyms-title']}>
                        {synonyms.length ? "Synonyms" : "Add Synonyms"}
                        {synonyms.length ? (
                            <div 
                            className={`${styles['synonyms-details']}`}
                        >
                            {synonyms.join(', ')}
                        </div>
                        ) : null} 
                    </div>
                    <i class="icon-Next"></i>
                </div>
                 {props.renderRipple()}
            </div>   
      )
    });

    return (
        <>
            <AddSynonyms {...props}/>
            {synonymsSlider ? <AddEditSynonyms
                 synonyms = {synonyms}
                 onHidden = {() => {
                    toggleSynonymsSlider(false);
                 }}
                 onSaveSynonyms = {onSaveSynonyms}
            ></AddEditSynonyms> : null}
        </>
    )
}

const mapStateToProps = (state, props) => {
	return {
		...props,
		isMobile:state.library.deviceData.isMobile
	}
}

export default withRipple(connect(mapStateToProps,{
    updateEditProductDetail
})(ProductSynonyms));


